// alterado - revisado

export const processaValoresDefaultIniciaisDespesasAcumuladasChart = ( values ) => {

    // O valor default do campo comSemDiaDiaEstudo foi implementado em
    // ClienteService - inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient
}